import { useQuery } from "@tanstack/react-query";
import { SecurityAppInvestigationsSummary } from "@graylog/enterprise-api";
import i18n from "i18n";
import { defaultOnError } from "util/conditional/onError";
const fetchAIReport = (investigationId) => SecurityAppInvestigationsSummary.investigationReport(investigationId).then((report) => report == null ? void 0 : report.text);
const useAiReport = (investigationId, enabled) => {
  const { data, isLoading, isFetching, isSuccess, isFetched, isError, error } = useQuery({
    queryKey: ["investigation-ai-report", investigationId],
    queryFn: () => defaultOnError(
      fetchAIReport(investigationId),
      i18n.t("notifications.fetch_ai_report_failed", { ns: "enterprise_security_investigations" }),
      i18n.t("notifications.could_not_fetch_ai_report", { ns: "enterprise_security_investigations" })
    ),
    enabled
  });
  return {
    data,
    isLoading,
    isFetching,
    isSuccess,
    isFetched,
    isError,
    error
  };
};
export default useAiReport;
